import React from 'react';
import './AdminPage.scss';
import { Badge, Calendar } from 'antd';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
    asyncFetchScoreTypes,
    asyncFetchUsers,
    asyncFetchUserScores,
} from 'store/reducers/users/thunks';
import ScoreHistory from 'layouts/scoreHistory/ScoreHistory';
import UserScoreForm from 'forms/userScoreForm/UserScoreForm';
import type { Moment } from 'moment';

function AdminPage(): React.ReactElement {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(asyncFetchUsers());
        dispatch(asyncFetchScoreTypes());
    }, [dispatch]);

    const [currentUserId, setCurrentUserId] = React.useState(0);

    const fetchUserScores = React.useCallback(
        (userId: number) => {
            setCurrentUserId(userId);
            dispatch(asyncFetchUserScores(userId));
        },
        [dispatch]
    );

    const { users, userScores } = useAppSelector(state => state.usersStore);
    const [date, setDate] = React.useState<Date>(new Date());

    const dateCellRender = (value: Moment): React.ReactElement => {
        return (
            <ul className="events">
                {userScores
                    .filter(
                        userScore =>
                            value.toDate().toDateString() ===
                            new Date(userScore.date).toDateString()
                    )
                    .map(userScore => {
                        return (
                            <li key={userScore.id}>
                                <Badge
                                    status={
                                        userScore.count > 0
                                            ? 'success'
                                            : 'error'
                                    }
                                    text={userScore.comment}
                                />
                            </li>
                        );
                    })}
            </ul>
        );
    };

    return (
        <div className="admin-page">
            <Calendar
                fullscreen
                onSelect={value => setDate(value.toDate())}
                dateCellRender={dateCellRender}
            />

            <div className="admin-page_users">
                {users.map(user => (
                    <button
                        type="button"
                        key={user.id}
                        onClick={() => fetchUserScores(user.id)}
                        className={`score-type-chip ${
                            currentUserId === user.id ? 'current-user' : ''
                        }`}
                    >
                        {user.first_name} {user.last_name}
                    </button>
                ))}
            </div>

            {!!currentUserId && (
                <UserScoreForm date={date} userId={currentUserId} />
            )}

            <ScoreHistory userScores={userScores} />
        </div>
    );
}

export default React.memo(AdminPage);
